import { breakpoint, colors, fontFamily, fontSize, fontWeight, mediaQueryHelper, spacing } from '@offerzen/pinata'
import { css } from '@emotion/css'

export const highlightTheme = () => {
  return css({
    color: `${colors.cornflowerBlue} !important`,
    background: `${colors.hawkesBlue} !important`,
  })
}

const CUSTOM_POPUP_BREAKPOINT = 321

const styles = {
  wrapper: css({
    marginTop: spacing.small,
  }),

  title: css({
    marginBottom: spacing.small,
  }),

  text: css({
    margin: 0,
  }),

  certification: css({
    color: colors.scorpion,
    fontWeight: fontWeight.semiBold,
  }),

  keywordHighlight: theme =>
    css({
      // eslint-disable-next-line no-undef
      ...keywordHighlight(theme),
    }),

  defaultTag: css({
    color: `${colors.scorpion} !important`,
    fontWeight: fontWeight.regular,
    backgroundColor: `${colors.porcelain} !important`,
    marginRight: 8,
    marginBottom: 8,
    fontSize: fontSize.default,
    [mediaQueryHelper(breakpoint.phone)]: {
      fontSize: fontSize.small,
    },
  }),

  moreText: css({
    color: colors.jumbo,
    fontWeight: fontWeight.regular,
    fontStyle: 'italic',
    fontSize: fontSize.default,
    whiteSpace: 'nowrap',

    [mediaQueryHelper(breakpoint.phone)]: {
      fontSize: fontSize.small,
    },
  }),

  hiddenInfo: css({
    display: 'flex',
    alignItems: 'center',
    marginTop: 16,
  }),

  hiddenInfoText: css({
    display: 'flex',
    color: colors.jumbo,
    fontWeight: fontWeight.semiBold,
    fontSize: fontSize.default,
    marginRight: 6,
    alignItems: 'center',
    [mediaQueryHelper(breakpoint.phone)]: {
      fontSize: fontSize.small,
    },
  }),

  popUp: css({
    padding: '14px',
    fontFamily: fontFamily.body,
    fontSize: fontSize.default,
    color: colors.blackPearl,
    lineHeight: '140%',

    p: {
      margin: 0,
    },

    a: {
      textDecoration: 'underline',
      color: colors.cornflowerBlue,
      cursor: 'pointer',
      fontWeight: fontWeight.bold,
    },
  }),

  modal: css({
    width: '240px',
    left: 0,
    top: 'calc(100% + 6px)',

    [mediaQueryHelper(CUSTOM_POPUP_BREAKPOINT)]: {
      width: '270px',
    },

    [mediaQueryHelper(breakpoint.phone)]: {
      width: '310px',
    },

    [mediaQueryHelper(breakpoint.tablet)]: {
      width: '340px',
    },
  }),
}
export default styles
